export const processChannelData = (data) => {
  return {
    ...data,
    updated_at_date: new Date(data.updated_at),
  };
};
